import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from '@containers/WishList/messages';

import { HeaderTitle, HeaderWrapper } from './styled';

type Props = {
  isShared: boolean;
};

export const WishlistHeader = ({ isShared }: Props) => {
  return (
    <HeaderWrapper>
      <HeaderTitle>
        <FormattedMessage
          {...(isShared ? messages.sharedProducts : messages.yourProducts)}
        />
      </HeaderTitle>
    </HeaderWrapper>
  );
};
